import { atom } from "jotai";
import uniqWith from "lodash/uniqWith";

import { fullyWatchedQueryAtom } from "./fully-watched-query.atom";
import { fullyWatchedSocketUpdatesAtom } from "./fully-watched-socket-updates.atom";

export const fullyWatchedItemsAtom = atom(async (get) => {
  const { data } = await get(fullyWatchedQueryAtom);
  const socket = get(fullyWatchedSocketUpdatesAtom);

  return uniqWith(
    [...data, ...socket],
    (a, b) => a.epg_entry.id === b.epg_entry.id,
  );
});
